/* eslint-disable react/jsx-pascal-case */

import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Card,
    Button,
    MultipleSelectorV2,
    Typography,
    Divider
} from '../../ui/ot'
import UploadImg from "./../../official_web/UploadImg";
import { useStaff } from '../../organization_structure/controllers/staff_controller'
const language_culture_code = 'zh-tw'
const SystemInformationForm = ({
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    permission_level = null, 
}) => {
    const [form] = Form.useForm();
    const [count, setCount] = useState(0);
    const editor = useRef(null);

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getStaffData({})
    };
    const onFinish = (values) => {
        onFormFinish(values);
    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    };

    const getLanguageLabel = (language_culture_code) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        return label[language_culture_code];
    };
    const getLanguageName = ({ language_culture_code, obj_language_data }) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        let nameValue = obj_language_data.find((element) => {
            return element?.language_culture_code === language_culture_code;
        })?.language_culture_value;
        return nameValue || "";
    };

    const setFieldValue = (name, value) => {
        if (propsForm) {
            propsForm.setValue(name, value);
        } else {
            form.setValue(name, value);
        }
    };
    const getAnyFormValue = (name, count) => {

        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };
    const {
        getStaffData,
        StaffData
    } = useStaff({
        onBefore: () => { },
        onFinish: () => { }
    })

    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);

    return (
        <Row gutter={[8, 8]}>

            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            {permission_level === 1 ?
                            <Button htmlType="submit">
                                儲存
                            </Button>
                            : <></>}
                        </Col>
                        <Col xxl={12}
                            xl={12}
                            lg={12}
                            md={24}
                            sm={24}
                            xs={24}
                            style={{ minHeight: '50vh' }}>
                            <Row>
                                <Col span={24}>
                                    <Form.Item hidden name="information_id">
                                        {/* <Input /> */}
                                    </Form.Item>
                                    <Form.List
                                        name={"name_language_data"}
                                    >
                                        {(fields) => <>
                                            {fields.map(field => <>
                                                <Form.Item hidden name={[field.name, "language_manage_id"]}>
                                                    {/* <Input /> */}
                                                </Form.Item>
                                                <Form.Item
                                                    label={<>
                                                        {/* <Label field={field} form={propsForm ? propsForm : form} /> */}
                                                        {getLanguageLabel(field.language_culture_code)}網站名稱
                                                    </>}
                                                    name={[field.name, "language_culture_value"]}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </>)}
                                        </>}
                                    </Form.List>
                                </Col>
                                <Col span={24}>
                                    <Form.Item label="系統時區" name="system_time_zone">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item label="系統語系" name="system_language">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                {["頁尾Logo", "Logo", "頁底圖片"].map((item, index) => <>
                                    <Form.Item
                                        hidden
                                        name={"classify_structure_type_information_data." + index + ".classify_structure_type_information_id"}
                                    >
                                    </Form.Item>
                                    <Form.Item
                                        hidden
                                        name={"classify_structure_type_information_data." + index + ".classify_structure_type_id"}
                                    >
                                    </Form.Item>
                                    <Col xxl={8}
                                        xl={8}
                                        lg={8}
                                        md={12}
                                        sm={24}
                                        xs={24}>
                                        <Form.Item
                                            hidden
                                            name={"classify_structure_type_information_data." + index + ".classify_structure_type_file_data.0.file_id"}
                                        >
                                        </Form.Item>
                                        <Row justify={'left'}>
                                            <Col span={24}>
                                                <Form.Item
                                                    name={"classify_structure_type_information_data." + index + ".title"}
                                                >
                                                    <span> {item}</span>
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>

                                                {permission_level === 1 ?
                                                <UploadImg
                                                    defaultValue={getAnyFormValue("classify_structure_type_information_data." + index + ".classify_structure_type_file_data", count) || []} ƒ
                                                    onImagesChange={(files) => {
                                                        const file =
                                                            files.findLast(() => true) || [];
                                                        console.log(file)
                                                        propsForm.setFieldValue(
                                                            "classify_structure_type_information_data." + index + ".classify_structure_type_file_data.0.file_id",
                                                            file?.file_id !== undefined ? file.file_id : file
                                                        );
                                                    }}
                                                />
                                                : <></>}
                                            </Col>
                                        </Row>
                                    </Col>
                                </>)}
                            </Row>
                        </Col>
                        <Col xxl={12}
                            xl={12}
                            lg={12}
                            md={24}
                            sm={24}
                            xs={24}
                        >
                            <Card title="基本聯絡資料設定"
                                styles={{ minHeight: '50vh' }}>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Row justify={"center"}>
                                            <Col span={24}>
                                                <Form.Item
                                                    label="聯絡人"
                                                    name="contact_person">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item

                                                    label="電話"
                                                    name="phone"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "請輸入電話",
                                                        },
                                                    ]}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label="地址"
                                                    name="address"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "請輸入地址",
                                                        },
                                                    ]}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item

                                                    label="電子信箱"
                                                    name="email"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "請輸入信箱",
                                                        },
                                                    ]}
                                                >
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Divider />
                        </Col>
                        <Col span={24}>
                            <Row gutter={[8, 8]} >
                                <Col span={24} >
                                    {/* 主標題 */}
                                    <Typography.Title level={3}
                                        style={{
                                            color: "#333", // 深色文字
                                            fontWeight: "700",
                                            margin: "0",
                                            lineHeight: "1.2",
                                            borderBottomWidth: 0
                                        }}
                                    >
                                        更多資訊設定
                                    </Typography.Title>
                                </Col>
                                <Col span={24}>
                                    <Row gutter={[8, 8]} align={'middle'}>
                                        <Col>
                                            選擇更多聯絡人：
                                        </Col>
                                        <Col>
                                            <MultipleSelectorV2
                                                value={getAnyFormValue('information_staff_data', count)?.map((select) => select?.staff_id)}
                                                name={'temp'}
                                                options={(StaffData || []).map((staff) => {
                                                    return {
                                                        label: staff?.staff_name,
                                                        value: staff?.staff_id
                                                    }
                                                })}
                                                onValueChange={(e) => {
                                                    let selectValueId = e.target.value || []
                                                    let staff = []
                                                    staff = selectValueId.map((id) => {
                                                        let staffIdData = StaffData.find((element) => element?.staff_id === id)
                                                        return {
                                                            ...staffIdData
                                                        }
                                                    })
                                                    setFieldValue('information_staff_data', staff)
                                                }}
                                                onChange={(value) => {
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <Form.List name="information_staff_data">
                                        {(fields, { add: addStaff, remove }) => (
                                            <Row gutter={[8, 8]} >
                                                {fields.map(({ name, id }, index) => (
                                                    <Col xxl={8}
                                                        xl={8}
                                                        lg={8}
                                                        md={12}
                                                        sm={24}
                                                        xs={24}>
                                                        <Card
                                                            key={id}
                                                            size="sm"
                                                            title={`聯絡人${index + 1}`}>
                                                            <Row gutter={[8, 8]} >
                                                                <Col span={24}>
                                                                    <Row justify={"end"}>
                                                                        <Col>
                                                                            <Button size={"small"} onClick={() => {
                                                                                setCount(pre => pre + 1)
                                                                                remove(index)
                                                                            }}>
                                                                                刪除
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col
                                                                    span={24}>
                                                                    <Form.Item hidden name={`${name}.information_staff_id`} >
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col
                                                                    span={24}>
                                                                    <Form.Item
                                                                        label="姓名"
                                                                        name={`${name}.staff_name`}>
                                                                        <Input
                                                                            key={id}

                                                                            disabled={true} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col
                                                                    span={24}>
                                                                    <Form.Item

                                                                        label="電話"
                                                                        name={`${name}.phone`}
                                                                    >
                                                                        <Input
                                                                            key={id}
                                                                            disabled={true} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col
                                                                    span={24}>
                                                                    <Form.Item

                                                                        label="電子信箱"
                                                                        name={`${name}.email`}

                                                                    >
                                                                        <Input
                                                                            key={id}
                                                                            disabled={true} />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>

                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        )}
                                    </Form.List>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
};

export default SystemInformationForm;

// const Label = ({
//     field,
//     form,
//     ...props
// }) => {
//     return <>
//         {Form.useWatch(['name_language_data', field.name, 'language_culture_name'], form)}
//     </>
// }